module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [(_vm.item.correction == false) ? _c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'InvoiceList'
      }
    }
  }, [_vm._v("Faktury sprzedażowe")]), _vm._v("/Nowa faktura\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.item.correction == true) ? _c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'InvoiceList'
      }
    }
  }, [_vm._v("Faktury sprzedażowe")]), _vm._v("/Korekta\n         ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-title__buttons"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading || _vm.agreementRetrieveLoading || _vm.correctionRetrieveLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showMessageInvoiceAlreadyCreated) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            Faktura dla wybranej umowy została już wygenerowana\n            "), _c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    attrs: {
      "to": {
        name: 'InvoiceShow',
        params: {
          id: _vm.showMessageInvoiceAlreadyCreated
        }
      },
      "title": "Pokaż"
    }
  }, [_vm._v("\n            Pokaż\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showMessageCorrectionAlreadyCreated) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            Korekta dla wybranej faktury została już wystawiona\n            "), _c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    attrs: {
      "to": {
        name: 'InvoiceShow',
        params: {
          id: _vm.showMessageCorrectionAlreadyCreated
        }
      },
      "title": "Pokaż"
    }
  }, [_vm._v("\n            Pokaż\n            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.agreementRetrieveLoading && !_vm.correctionRetrieveLoading) ? _c('InvoiceForm', {
    attrs: {
      "handle-submit": _vm.handleSubmit,
      "values": _vm.item,
      "errors": _vm.violations
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae36fe0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/Create.vue
// module id = 778
// module chunks = 0